@if (isIncorrectCode()) {
  <div class="flex-column align-items-center gap-1 text-center">
    <div class="flex align-items-center gap-1 text-12 bold color-dark">
      <shared-icon icon="danger-square" fill="var(--color-red)" height="1rem" width="1rem" />
      Code is incorrect
    </div>
    <div class="text-12">{{ incorrectCodeHint() }}</div>
  </div>
} @else if (hasError()) {
  <div class="flex-column align-items-center gap-1 text-center">
    <div class="text-14">Unexpected error occurred!</div>
    <div class="text-12">We are really sorry about this! Please try again later, or contact customer support.</div>
  </div>
}
